import { render, staticRenderFns } from "./couponPoster.vue?vue&type=template&id=23bb54ea&scoped=true&"
import script from "./couponPoster.vue?vue&type=script&lang=js&"
export * from "./couponPoster.vue?vue&type=script&lang=js&"
import style0 from "./couponPoster.vue?vue&type=style&index=0&id=23bb54ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bb54ea",
  null
  
)

export default component.exports